
const NOMRALIZE_CONSTANT = 90,
  M = 'M',
  A = 'A',
  L = 'L',
  Z = 'Z',
  C = 'C',
  PI = Math.PI,
  SIN = Math.sin,
  COS = Math.cos,
  PI2 = PI * 2,
  HALF_PI = PI / 2,
  SMALLSQUARE = '&#9632;',
  MEDIUMSQUARE = '&#9724;';

function normaliseAngle (angle) {
  return angle - NOMRALIZE_CONSTANT;
}

function isAngleInLeftHemisphere (_rotationAngle) {
  return Math.abs(_rotationAngle) > 90 && Math.abs(_rotationAngle) < 270;
}

function isAngleInTopHemisphere (_angle) {
  return Math.abs(_angle) > 180 && Math.abs(_angle) < 360;
}

function getCartesianDistance (x1, y1, x2, y2) {
  return Math.sqrt(
    ((
      x2 - x1) * (x2 - x1)
    ) +
    ((
      y2 - y1) * (y2 - y1)
    ));
}

function getArcLength (_radius, _startAngle, _endAngle) {
  return PI2 * _radius * (Math.abs(_endAngle - _startAngle)) / 360;
}

/**
 * Text is rotated according to which quadrant of the circle it is
 * currently placed in
 */
function getTextRotationByQuadrant (_angle) {
  let rotationAngle = _angle;
  if (isAngleInLeftHemisphere(rotationAngle)) {
    rotationAngle = (rotationAngle - 180);
  }

  return rotationAngle;
}

export {
  M,
  A,
  L,
  Z,
  C,
  PI,
  SIN,
  COS,
  PI2,
  HALF_PI,
  SMALLSQUARE,
  MEDIUMSQUARE,
  normaliseAngle,
  getArcLength,
  getTextRotationByQuadrant,
  isAngleInLeftHemisphere,
  isAngleInTopHemisphere,
  getCartesianDistance
};
